import { useState, useRef } from "react";
import { disposables as o } from "../utils/disposables.js";
import { useDisposables as p } from "./use-disposables.js";
import { useFlags as c } from "./use-flags.js";
import { useIsoMorphicEffect as n } from "./use-iso-morphic-effect.js";
var T;
typeof process != "undefined" && typeof globalThis != "undefined" && ((T = process == null ? void 0 : process.env) == null ? void 0 : T["NODE_ENV"]) === "test" && typeof Element.prototype.getAnimations == "undefined" && (Element.prototype.getAnimations = function() {
  return console.warn(["Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.", "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.", "", "Example usage:", "```js", "import { mockAnimationsApi } from 'jsdom-testing-mocks'", "mockAnimationsApi()", "```"].join(`
`)), [];
});
var A = ((r) => (r[r.None = 0] = "None", r[r.Closed = 1] = "Closed", r[r.Enter = 2] = "Enter", r[r.Leave = 4] = "Leave", r))(A || {});
function H(e) {
  let n2 = {};
  for (let t in e) e[t] === true && (n2[`data-${t}`] = "");
  return n2;
}
function R(e, n$1, t, i) {
  let [r, o2] = useState(t), { hasFlag: s, addFlag: a, removeFlag: l } = c(e && r ? 3 : 0), u = useRef(false), f = useRef(false), b = p();
  return n(() => {
    var d;
    if (e) {
      if (t && o2(true), !n$1) {
        t && a(3);
        return;
      }
      return (d = i == null ? void 0 : i.start) == null || d.call(i, t), L(n$1, { inFlight: u, prepare() {
        f.current ? f.current = false : f.current = u.current, u.current = true, !f.current && (t ? (a(3), l(4)) : (a(4), l(2)));
      }, run() {
        f.current ? t ? (l(3), a(4)) : (l(4), a(3)) : t ? l(1) : a(1);
      }, done() {
        var p2;
        f.current && typeof n$1.getAnimations == "function" && n$1.getAnimations().length > 0 || (u.current = false, l(7), t || o2(false), (p2 = i == null ? void 0 : i.end) == null || p2.call(i, t));
      } });
    }
  }, [e, t, n$1, b]), e ? [r, { closed: s(1), enter: s(2), leave: s(4), transition: s(2) || s(4) }] : [t, { closed: void 0, enter: void 0, leave: void 0, transition: void 0 }];
}
function L(e, { prepare: n2, run: t, done: i, inFlight: r }) {
  let o$1 = o();
  return M(e, { prepare: n2, inFlight: r }), o$1.nextFrame(() => {
    t(), o$1.requestAnimationFrame(() => {
      o$1.add(C(e, i));
    });
  }), o$1.dispose;
}
function C(e, n2) {
  var o$1, s;
  let t = o();
  if (!e) return t.dispose;
  let i = false;
  t.add(() => {
    i = true;
  });
  let r = (s = (o$1 = e.getAnimations) == null ? void 0 : o$1.call(e).filter((a) => a instanceof CSSTransition)) != null ? s : [];
  return r.length === 0 ? (n2(), t.dispose) : (Promise.allSettled(r.map((a) => a.finished)).then(() => {
    i || n2();
  }), t.dispose);
}
function M(e, { inFlight: n2, prepare: t }) {
  if (n2 != null && n2.current) {
    t();
    return;
  }
  let i = e.style.transition;
  e.style.transition = "none", t(), e.offsetHeight, e.style.transition = i;
}
export {
  H as transitionDataAttributes,
  R as useTransition
};
